module.exports = __webpack_public_path__ + "static/media/free-ads.d15e391b.png";